import { Suspense } from 'react';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { RouteErrorBoundary } from '@inbody/error';

import { MainLayout } from '../../layout';
import { basePageRoute } from './RouterObject';

const browserRouter = createBrowserRouter([
  {
    errorElement: <RouteErrorBoundary />,
    element: <MainLayout />,
    children: basePageRoute,
  },
]);

export const BrowserRouter = () => {
  return (
    <Suspense fallback={<div>Loading</div>}>
      <RouterProvider router={browserRouter} />
    </Suspense>
  );
};
